module.exports = __webpack_public_path__ + "img/avatar-30.6b14bde2.png";